// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2r8f3","title":"Images90_title__1gor1","images":"Images90_images__2vde0"};